export default class OspreyTestMessage {
    alealert
    static __generatePostFakeResponse(body) {
        return {
            headers: {
                post: () => 'application/json'
            },
            data: body
        }
    }

    static __send() {

        return true
    }

    static post(path, params) {
        return new Promise((resolve, reject) => {
            let data = null

            const pathParts = path.split('/').filter(p => p)

            const [messageRoute, subRoute] = pathParts

            if (messageRoute !== 'testMessage') {
                reject(new Error('invalid route'))
            }

            if (!subRoute) {
                data = this.__send(params)
            }

            resolve(this.__generatePostFakeResponse(data))
        })
    }
}


// WEBPACK FOOTER //
// src/services/osprey-api/api-test-message.js